export { default as Summary } from './Summary';



// WEBPACK FOOTER //
// ./src/pages/Control/Summary/index.js